// 把 /v1/expo/challenge/list 回傳的 schedules 陣列，正規化成 ScheduleDayTabs 需要的
// { year, month, date, weekday, entries } 陣列，依 start_time 分組並排序
//
// 注意：API 回傳的時間字串雖標記 GMT，但寫入的其實就是活動現場（台灣）的實際時間，
// 不是真的 UTC 時間，因此一律用 getUTC* 方法讀取，不做時區轉換，避免依裝置時區跑掉。

const COURT_COLORS = {
  A: '#BC313D',
  B: '#226B68',
  C: '#004682',
  D: '#592181',
  E: '#C59B5A',
  F: '#DE136A',
}
const DEFAULT_COURT_COLOR = '#6E625B'

const WEEKDAY_LABELS = ['日', '一', '二', '三', '四', '五', '六']

export function groupSchedulesByDay(schedules) {
  const dayMap = new Map()
  const sorted = [...schedules].sort((a, b) => new Date(a.start_time) - new Date(b.start_time))

  sorted.forEach((schedule) => {
    const start = new Date(schedule.start_time)
    const dayKey = `${start.getUTCFullYear()}-${start.getUTCMonth()}-${start.getUTCDate()}`

    if (!dayMap.has(dayKey)) {
      dayMap.set(dayKey, {
        year: start.getUTCFullYear(),
        month: String(start.getUTCMonth() + 1),
        date: String(start.getUTCDate()),
        weekday: WEEKDAY_LABELS[start.getUTCDay()],
        entries: [],
      })
    }

    dayMap.get(dayKey).entries.push(toEntry(schedule))
  })

  return Array.from(dayMap.values())
}

function toEntry(schedule) {
  if (schedule.is_break) {
    return {
      type: 'break',
      label: '休息時間',
      time: `${formatTime(schedule.start_time)}-${formatTime(schedule.end_time)}`,
    }
  }

  return {
    type: 'match',
    match: schedule.match,
    category: schedule.category,
    arrivalTime: formatTime(schedule.arrival_time),
    matchTime: formatTime(schedule.start_time),
    departureTime: formatTime(schedule.end_time),
    matchups: (schedule.entries ?? []).map((entry) => ({
      team: entry.court,
      teamColor: COURT_COLORS[entry.court] ?? DEFAULT_COURT_COLOR,
      isCourt: entry.court in COURT_COLORS,
      name: entry.team_name,
      isWinner: !!schedule.winner_team_name && entry.team_name === schedule.winner_team_name,
    })),
  }
}

function formatTime(isoString) {
  if (!isoString) return ''
  const d = new Date(isoString)
  const hh = String(d.getUTCHours()).padStart(2, '0')
  const mm = String(d.getUTCMinutes()).padStart(2, '0')
  return `${hh}:${mm}`
}
